import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { gridProperties } from '@/services/column.config'
import {
  calculateGridHeight,
  showNotification,
  calculatePerimeterBuildingFootprint,
  customComparator,
} from '@/services/calculate'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
    'export-template': exportTemplates,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'area') {
        const reg = /^(?!$)\d{0,9}(?:\\d{9})?$/
        if (!reg.test(value)) {
          callback(
            new Error(
              'Area should consist of 9 digits only (For e.g.:  123456789)!',
            ),
          )
        } else if (value > 9999999) {
          callback(
            new Error(
              'Area should less than or equals to 9999999!',
            ),
          )
        } else {
          callback()
        }
      } else if (String(value).length > 100) {
        callback(
          new Error('Grouping must be less than or equals to 100 characters'),
        )
      } else {
        callback()
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'label',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      groupingBankList: [],
      visible: false,
      modalTitle: '',
      form: {
        label: undefined,
        area: undefined,
        isActive: 1,
      },
      rules: {
        label: [
          { required: true, message: 'Please enter grouping', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        area: [
          { required: true, message: 'Please enter area', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      exportClicked: false,
      tableState: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'))
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteBank', this.deleteBank)
    this.$root.$on('cloneBank', this.cloneBank)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '10') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.groupingBankList = []
        this.loading = true
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('deleteBank')
    this.$root.$off('cloneBank')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked) return false
          else return true
        }
      }
      this.columnDefs = gridProperties.master.columns.groupingBank
    },

    // Refresh Grouping Banks
    refreshBanks() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.groupingBankList = []
      this.page = 0
      this.defaultSortedBy = 'label'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'label',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getBanks(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Grouping Bank
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Grouping'
      this.form.label = undefined
      this.form.value = null
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Check Number Event
    isNumber(evt) {
      evt = !evt ? window.event : evt
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      }
    },

    // Save Grouping Bank
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let req = {
            label: this.form.label,
            area: this.form.area,
            perimeter: calculatePerimeterBuildingFootprint(this.form.area),
          }
          let url = masterAPIs.groupingBank.add
          if (this.modalTitle === 'Copy') {
            req = this.form
            url = masterAPIs.groupingBank.clone(this.form.id)
          }
          instance
            .post(url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                'Create Grouping Bank',
                'Grouping Bank created successfully!',
              )
              const id = _.get(response.data, 'result.id', undefined)
              this.$refs.ruleForm.resetFields()
              this.$router.push(`grouping-bank/${id}`)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load Grouping Banks
    getBanks(params, type) {
      instance
        .post(masterAPIs.groupingBank.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          label: _.get(this.filters, 'label', undefined),
          area: _.get(this.filters, 'area', undefined),
          perimeter: _.get(this.filters, 'perimeter', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.groupingBankList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'groupingBankTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.deleteMaster(screenType.groupingBank), ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Grouping Bank',
            'Data has been deleted successfully!',
          )
          this.refreshBanks()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Grouping Banks
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected grouping bank ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              grouping bank
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Grouping Bank
    deleteBank(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.label}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this grouping
              bank
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.groupingBankList = []
      if (sortData.length > 0) {
        this.defaultSortedBy =
          sortData[0]['colId'] === 'label' ? 'label' : sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'label'
        this.defaultSortOrder = true
      }
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'groupingBankTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.groupingBankList = []
      this.selectedRowKeys = []
      this.getBanks(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.groupingBankList = []
      this.loading = true
      this.page = 0
      this.getBanks(this.gridOptions)
    },

    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    // Copy Grouping Bank
    cloneBank(data) {
      this.visible = true
      this.modalTitle = 'Copy'
      this.form.label = data.label + ' - Copy'
      this.form.id = data.id
      this.form.isActive = data.isActive
      this.form.area = data.area
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.masterGroupingBank,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.masterGroupingBank))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getBanks(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = false
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'label'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'label',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
